import htmlToElement from 'html-to-element';

export default class Buttons {
  constructor(assetBase, data, onclick) {
    this.data = data;
    this.assetBase = assetBase;
    this.onclick = onclick;
    this.items = [];
    this.videoRelativeCoantainer = document.querySelector('.controls--video_relative');
    this.viewportRelativeCoantainer = document.querySelector('.controls--viewport_relative');
    if (data) this.build();
  }

  build() {
    // is called on instanciation
    this.data.forEach((item) => {
      const html = `
        <div class="button-container" >
          <div class="button" data-type="${item.type}" style="display:none;">
            <span class="button__text">${item.title}</span>
          </div>
        </div>`;

      const buttonContainer = htmlToElement(html);
      const button = buttonContainer.querySelector('.button');
      this.items.push(button);

      // set button if exists

      if (item.id) button.id = `button-${item.id}`;

      // set pivot if exists and valid

      let justify = 'center';
      let align = 'center';
      if (item.config.position.pivot && item.config.position.pivot.match(/^([center|bottom|top]+)-([center|left|right]+)/)) {
        switch (item.config.position.pivot.split('-')[1]) {
          case 'center':
            justify = 'center';
            break;
          case 'left':
            justify = 'flex-start';
            break;
          case 'right':
            justify = 'flex-end';
            break;
          default:
        }

        switch (item.config.position.pivot.split('-')[0]) {
          case 'center':
            align = 'center';
            break;
          case 'top':
            align = 'flex-start';
            break;
          case 'bottom':
            align = 'flex-end';
            break;
          default:
        }
      }

      buttonContainer.style.justifyContent = justify;
      buttonContainer.style.alignItems = align;

      // set position

      buttonContainer.style.bottom = `${item.config.position.y}%`;
      buttonContainer.style.left = `${item.config.position.x}%`;

      // custom classes

      if (item.config.classes) {
        button.className += ` ${item.config.classes}`;
      }

      // icon if exists
      if (item.config.icon) {
        const icon = htmlToElement(`
          <i style="background-image: url(${this.assetBase + item.config.icon.src})"></i>,
          `);

        if (item.config.icon.position && item.config.icon.position === 'before') {
          button.prepend(icon);
        } else {
          button.append(icon);
        }
      }

      // animate

      if (!item.config.animation) item.config.animation = {};

      item.config.animation = {
        delay: 0,
        duration: 500,
        repeat: 1,
        entrance: 'fadeInDown',
        exit: 'fadeOutUp',
        ...item.config.animation,
      };

      button.style.setProperty('--animate-delay', `${item.config.animation.delay}ms`);

      button.style.setProperty('--animate-duration', `${item.config.animation.duration}ms`);

      button.style.setProperty('--animate-repeat', item.config.animation.repeat);

      button.classList.add('animate__animated');
      button.dataset.entranceAnimation = item.config.animation.entrance;

      button.dataset.exitAnimation = item.config.animation.exit;

      button.addEventListener('click', (e) => {
        this.onclick(e, item);
      });

      if (item.config.position.relative_to === 'viewport') {
        this.viewportRelativeCoantainer.appendChild(buttonContainer);
      } else {
        this.videoRelativeCoantainer.appendChild(buttonContainer);
      }
    });
  }

  /**
   * Show buttons with animation
   *
   * @async
   * @function show
   * @param {(null, 'all'|'hotspot'|'navigation')} type - Type of the buttons to hide
   * @param {clear} [clear=false] - Remove DOM-Elements after Animation
   * @return {Promise<String>} The data from the URL.
   */
  show(type = false) {
    let animationEndCount = 0;

    return new Promise((resolve, reject) => {
      if (!this.items || !this.items.length) resolve();
      const buttons = type ? this.items.filter((i) => i.dataset.type === type) : this.items;

      buttons.forEach((button, i) => {
        const onAnimationEnd = (e) => {
          animationEndCount += 1;
          e.target.removeEventListener('animationend', onAnimationEnd);
          button.style.setProperty('--animate-repeat', 1);

          if (animationEndCount === buttons.length) {
            // all there
            resolve();
          }
        };

        button.style.removeProperty('display');
        button.classList.remove(`animate__${button.dataset.exitAnimation}`);
        button.classList.add(`animate__${button.dataset.entranceAnimation}`);
        button.addEventListener('animationend', onAnimationEnd);
      });
    });
  }

  /**
   * Hide buttons with animation
   *
   * @async
   * @function hide
   * @param {(null, 'all'|'hotspot'|'navigation')} type - Type of the buttons to hide
   * @return {Promise<String>} The data from the URL.
   */
  hide(type = false) {
    let animationEndCount = 0;
    return new Promise((resolve, reject) => {
      if (!this.items || !this.items.length) resolve();

      const buttons = type ? this.items.filter((i) => i.dataset.type === type) : this.items;

      buttons.forEach((button, i) => {
        button.classList.remove(`animate__${button.dataset.entranceAnimation}`);
        button.classList.add(`animate__${button.dataset.exitAnimation}`);

        const onAnimationEnd = (e) => {
          animationEndCount += 1;
          e.target.removeEventListener('animationend', onAnimationEnd);
          e.target.style.display = 'none';
          if (animationEndCount === buttons.length) {
            // all gone
            resolve('all gone');
          }
        };

        button.addEventListener('animationend', onAnimationEnd);
      });
    });
  }

  async clear() {
    if (!this.items || !this.items.length) return;
    await this.hide();
    this.items.forEach((button) => {
      button.parentNode.remove();
    });
  }
}
